var __jsx = React.createElement;
import React from 'react';
import { GlobalModalStyle } from './styles';
import Modal from '@spa/shared/components/Modal';
import Reviews from '@spa/shared/components/Reviews';
var ReviewsModal = function ReviewsModal(_ref) {
  var _bookingReviews$revie;
  var _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
    bookingReviews = _ref.bookingReviews;
  var reviews = bookingReviews === null || bookingReviews === void 0 ? void 0 : (_bookingReviews$revie = bookingReviews.review_aggregates) === null || _bookingReviews$revie === void 0 ? void 0 : _bookingReviews$revie.items;
  return __jsx(Modal, {
    className: "modal-features",
    onClose: onClose
  }, __jsx(GlobalModalStyle, null), __jsx(Reviews, {
    bookingReviews: bookingReviews,
    reviews: reviews,
    showMore: false
  }));
};
export default ReviewsModal;